import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Breadcrumb from "../../../../components/common/Breadcrumbs";
import { useGetRecordAuditByIdQuery } from "../recordAuditApi";
import { formatValueAsDateAndTime } from "../../../../helpers/utils/DateUtils";

const RecordAuditDetailPage: React.FC = () => {

    const [crumbs] = useState([
        { content: "Home", url: "/home" },
        { content: "Record Audit", url: "/record-audit" },
        { content: "Record Audit Detail", url: "" }
    ]);

    const flattenObject = (obj: { [key: string]: any }, parentKey = ''): Record<string, any> => {
        return Object.keys(obj).reduce<Record<string, any>>((acc, key) => {
            const newKey = parentKey ? `${parentKey}.${key}` : key;
            if (typeof obj[key] === 'object' && obj[key] !== null) {
                return { ...acc, ...flattenObject(obj[key], newKey) };
            } else {
                return { ...acc, [newKey]: obj[key] };
            }
        }, {});
    };

    const [dataRows, setDataRows] = useState<{ key: string; initialValue: any; changedValue: any }[]>([]);
    const { auditId } = useParams();
    const { data: recordAuditData } = useGetRecordAuditByIdQuery(auditId);
    useEffect(() => {
        if (!recordAuditData?.changedValue) {
            console.warn("Changed value is missing or invalid", recordAuditData);
            return;
        }
    
        let changedValueObject = {};
        let initialValueObject = {};
    
        try {
            changedValueObject = JSON.parse(recordAuditData.changedValue);
        } catch (error) {
            console.error("Error parsing changedValue:", error);
        }
    
        try {
            initialValueObject = recordAuditData.initialValue ? JSON.parse(recordAuditData.initialValue) : {};
        } catch (error) {
            console.error("Error parsing initialValue:", error);
        }
    
        const flattenedChangedValue = flattenObject(changedValueObject);
        const flattenedInitialValue = flattenObject(initialValueObject);
    
        const allKeys = new Set([...Object.keys(flattenedChangedValue), ...Object.keys(flattenedInitialValue)]);
        const rows = Array.from(allKeys).map((key) => {
            let initialValue = flattenedInitialValue[key] !== undefined ? flattenedInitialValue[key] : 'null';
            let changedValue = flattenedChangedValue[key] !== undefined ? flattenedChangedValue[key] : 'null';
    
            if (key.endsWith("Date") || key.endsWith("PeriodStart") || key.endsWith("PeriodEnd")) {
                initialValue = initialValue !== 'null' ? formatValueAsDateAndTime(initialValue) : initialValue;
                changedValue = changedValue !== 'null' ? formatValueAsDateAndTime(changedValue) : changedValue;
            }
    
            return { key, initialValue, changedValue };
        });
    
       
    
        setDataRows(rows);
    }, [recordAuditData]);
    



    return (
        <div className="adduser_container px-4 py-2">
            <div className="justify-between sm:block md:flex lg:flex">
                <Breadcrumb crumbs={crumbs} />
                {/* <AuditableInfoButton obj={followUpData} /> */}
            </div>


            {/* Audit Info Card */}
            <div className="bg-text-1 p-5 rounded-lg shadow-md">
                <ul className="grid grid-cols-2 gap-4 list-none p-0 m-0">
                    <li>
                        <p>
                            <strong className="font-semibold">Table name :</strong>{" "}
                            {recordAuditData?.entityTypeName}
                        </p>
                    </li>
                    <li>
                        <p>
                            <strong className="font-semibold">Audited Entity Id :</strong>{" "}
                            {recordAuditData?.auditedEntityId}
                        </p>
                    </li>
                    <li>
                        <p>
                            <strong className="font-semibold">Audit Action Type :</strong>{" "}
                            {recordAuditData?.auditActionType}
                        </p>
                    </li>
                    <li>
                        <p>
                            <strong className="font-semibold">Created By :</strong>{" "}
                            {recordAuditData?.createdBy || ""}
                        </p>
                    </li>
                    <li className="col-span-2">
                        <p>
                            <strong className="font-semibold">Created On :</strong>{" "}
                            {recordAuditData?.creationDate ? new Date(recordAuditData?.creationDate).toLocaleString() : ""}
                        </p>
                    </li>
                </ul>
            </div>


            {/* Table */}
            <div className="mt-4">
                <table className="w-full">
                    <thead className="bg-highlight-5 text-text-0">
                        <tr>
                            <th className="px-4 py-2 text-left">Name</th>
                            <th className="px-4 py-2 text-left">Before</th>
                            <th className="px-4 py-2 text-left">After</th>
                        </tr>
                    </thead>
                    <tbody>
                        {dataRows.length === 0 ? (
                            <tr>
                                <td colSpan={3} className="text-center text-gray-500 p-4">No data available</td>
                            </tr>
                        ) : (
                            dataRows.map((row) => (
                                <tr key={row.key} className="odd:bg-text-1 hover:bg-text-1 transition cursor-pointer">
                                    <td className="px-4 py-2">{row.key}</td>
                                    <td className="px-4 py-2">{row.initialValue}</td>
                                    <td className="px-4 py-2">{row.changedValue}</td>
                                </tr>
                            ))
                        )}
                    </tbody>

                </table>
            </div>
        </div>
    );
};

export default RecordAuditDetailPage;
